// Author Liang Gang Qiang
// Date 2021-11-08 16:37:42

import * as model from "@/model/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdPelletizingIngredientPlan(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
